import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";
import SDKRootRoute from "./SDKRootRoute";
import SDKRoute from "./SDKRoute";

export const sdkRoute: NonIndexRouteObject = {
  element: <SDKRootRoute />,
  errorElement: <RouterErrorBox />,
  children: [
    {
      index: true,
      element: <SDKRoute />,
    },
  ],
};
